document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.getElementById('ProductMainImage');
  thumbs.forEach(function (thumb, index) {
    if (index === 0) thumb.classList.add('is-active');
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-image-src');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var heroThumbs = document.querySelectorAll('.hero-thumb');
  var heroMainImage = document.getElementById('HeroMainImage');
  heroThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (heroMainImage) heroMainImage.src = thumb.getAttribute('data-image-src');
      heroThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var heroThumbsMore = document.getElementById('HeroThumbsMore');
  var heroThumbsContainer = document.getElementById('HeroThumbs');
  if (heroThumbsMore && heroThumbsContainer) {
    heroThumbsMore.addEventListener('click', function () {
      heroThumbsContainer.classList.toggle('is-expanded');
    });
  }

  initBundleBuilder();
  applyPackFromQuery();
  initCountdownTimers();
  initSmoothAnchorScroll();
  initStickyBar();
  initSocialProofToast();
  initCartDrawer();
});

function initCartDrawer() {
  var overlay = document.getElementById('CartDrawerOverlay');
  var drawer = document.getElementById('CartDrawer');
  if (!overlay || !drawer) return;

  var closeBtn = document.getElementById('CartDrawerClose');
  var continueBtn = document.getElementById('CartDrawerContinue');
  var checkoutBtn = document.getElementById('CartDrawerCheckout');
  var iconBtn = document.getElementById('CartIconButton');
  var itemsEl = document.getElementById('CartDrawerItems');
  var emptyEl = document.getElementById('CartDrawerEmpty');
  var subtotalEl = document.getElementById('CartDrawerSubtotal');
  var countEl = document.getElementById('CartIconCount');
  var upsellAddBtn = document.getElementById('CartUpsellAdd');

  function formatMoney(cents, currency) {
    var amount = '$' + Math.round(cents / 100).toLocaleString('es-MX');
    return currency ? amount + ' ' + currency : amount;
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    if (!cart.items.length) {
      if (emptyEl) emptyEl.hidden = false;
    } else {
      if (emptyEl) emptyEl.hidden = true;
      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'cart-drawer-item';

        if (item.image) {
          var img = document.createElement('img');
          img.className = 'cart-drawer-item-img';
          img.src = item.image + '&width=120';
          img.alt = '';
          row.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'cart-drawer-item-info';
        var titleEl = document.createElement('p');
        titleEl.className = 'cart-drawer-item-title';
        titleEl.textContent = item.product_title;
        var variantEl = document.createElement('p');
        variantEl.className = 'cart-drawer-item-variant';
        variantEl.textContent = (item.variant_title ? item.variant_title + ' — ' : '') + 'Cantidad: x' + item.quantity;
        info.appendChild(titleEl);
        info.appendChild(variantEl);
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            var val = item.properties[key];
            if (!val) return;
            var propEl = document.createElement('p');
            propEl.className = 'cart-drawer-item-variant';
            propEl.textContent = key + ': ' + val;
            info.appendChild(propEl);
          });
        }
        row.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'cart-drawer-item-actions';
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-drawer-item-remove';
        removeBtn.setAttribute('aria-label', 'Quitar');
        removeBtn.setAttribute('data-line-key', item.key);
        removeBtn.innerHTML = '&times;';
        actions.appendChild(removeBtn);
        row.appendChild(actions);

        itemsEl.appendChild(row);
      });
      itemsEl.querySelectorAll('.cart-drawer-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeItem(btn.getAttribute('data-line-key'));
        });
      });
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    }
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  function openCart() {
    fetchCart();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-locked');
  }

  function closeCart() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-locked');
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (continueBtn) continueBtn.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);
  if (iconBtn) iconBtn.addEventListener('click', openCart);
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (typeof window.nyClick === 'function') {
        window.nyClick();
      } else {
        window.location.href = '/checkout';
      }
    });
  }
  if (upsellAddBtn) {
    upsellAddBtn.addEventListener('click', function () {
      var variantId = upsellAddBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      upsellAddBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('upsell-add-failed');
          return fetchCart();
        })
        .then(function () {
          upsellAddBtn.disabled = false;
          upsellAddBtn.textContent = 'Agregado ✓';
        })
        .catch(function () {
          upsellAddBtn.disabled = false;
          upsellAddBtn.textContent = 'No se pudo agregar, intenta de nuevo';
        });
    });
  }

  fetchCart();
  window.openCartDrawer = openCart;
}

function applyPackFromQuery() {
  var params = new URLSearchParams(window.location.search);
  var pack = params.get('pack');
  if (!pack) return;
  var target = document.querySelector('[data-set-quantity="' + pack + '"]');
  if (target) target.click();
}

function initSmoothAnchorScroll() {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (history.pushState) history.pushState(null, '', '#' + id);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

function initCountdownTimers() {
  var timers = document.querySelectorAll('[data-countdown]');
  timers.forEach(function (el) {
    var minutes = parseInt(el.getAttribute('data-countdown-minutes'), 10) || 120;
    var cycleMs = minutes * 60 * 1000;
    var timeEl = el.querySelector('[data-countdown-time]');
    if (!timeEl) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      var remaining = cycleMs - (Date.now() % cycleMs);
      var totalSeconds = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;
      timeEl.textContent = pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initStickyBar() {
  var bar = document.getElementById('StickyCtaBar');
  var offerCard = document.querySelector('.offer-card');
  var stickyBtn = document.getElementById('StickyCtaButton');
  var addButton = document.getElementById('AddBundleToCart');
  if (!bar || !offerCard) return;

  function checkVisibility() {
    var rect = offerCard.getBoundingClientRect();
    var pastOffer = rect.bottom < 0;
    bar.classList.toggle('is-visible', pastOffer);
  }

  window.addEventListener('scroll', checkVisibility, { passive: true });
  checkVisibility();

  if (stickyBtn && addButton) {
    stickyBtn.addEventListener('click', function () {
      addButton.click();
    });
  }
}

function initSocialProofToast() {
  var dataEl = document.getElementById('SocialProofData');
  var toast = document.getElementById('SocialProofToast');
  if (!dataEl || !toast) return;

  var items;
  try {
    items = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  items = items.filter(function (item) { return item && item.name && item.purchasedAt; });
  if (!items.length) return;

  var avatarEl = document.getElementById('SocialProofAvatar');
  var textEl = document.getElementById('SocialProofText');
  var timeEl = document.getElementById('SocialProofTime');
  var closeBtn = document.getElementById('SocialProofClose');

  var index = 0;
  var dismissed = false;
  var visibleMs = 6000;
  var gapMs = 9000;

  function timeAgo(iso) {
    var then = new Date(iso).getTime();
    if (isNaN(then)) return '';
    var diffMs = Date.now() - then;
    if (diffMs < 0) return 'hace un momento';
    var mins = Math.floor(diffMs / 60000);
    if (mins < 60) return 'hace ' + Math.max(mins, 1) + ' min';
    var hours = Math.floor(mins / 60);
    if (hours < 24) return 'hace ' + hours + ' h';
    var days = Math.floor(hours / 24);
    return 'hace ' + days + ' día' + (days === 1 ? '' : 's');
  }

  function showNext() {
    if (dismissed || index >= items.length) return;
    var item = items[index];
    index++;
    if (avatarEl) avatarEl.textContent = item.name.charAt(0).toUpperCase();
    if (textEl) {
      var location = item.city ? ' (' + item.city + ')' : '';
      textEl.textContent = item.name + location + ' compró ' + (item.product || 'un pack Serena');
    }
    if (timeEl) timeEl.textContent = timeAgo(item.purchasedAt);
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(hideToast, visibleMs);
  }

  function hideToast() {
    toast.classList.remove('is-visible');
    setTimeout(function () {
      toast.hidden = true;
      if (!dismissed && index < items.length) setTimeout(showNext, gapMs);
    }, 400);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      hideToast();
    });
  }

  setTimeout(showNext, 4000);
}

function initBundleBuilder() {
  var optionsDataEl = document.getElementById('ProductOptionsData');
  var variantsDataEl = document.getElementById('ProductVariantsData');
  var addButton = document.getElementById('AddBundleToCart');
  var errorEl = document.getElementById('BundleError');
  var colorGrid = document.getElementById('ColorPackGrid');
  var sizeRow = document.getElementById('SizeBtnRow');
  if (!optionsDataEl || !variantsDataEl || !addButton || !colorGrid || !sizeRow) return;

  var options = JSON.parse(optionsDataEl.textContent); // [{name, position, values}, ...]
  var variants = JSON.parse(variantsDataEl.textContent); // [{id, option1, option2, ..., available}, ...]
  var colorIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'color'; });
  var sizeIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'size'; });
  var packIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'paquete'; });

  function findVariant(color, size, pack) {
    return variants.find(function (v) {
      var matchesColor = colorIndex === -1 || v['option' + (colorIndex + 1)] === color;
      var matchesSize = sizeIndex === -1 || v['option' + (sizeIndex + 1)] === size;
      var matchesPack = packIndex === -1 || !pack || v['option' + (packIndex + 1)] === pack;
      return matchesColor && matchesSize && matchesPack;
    });
  }

  var state = {
    qty: 2,
    pack: null,
    mode: 'simple',
    color: colorGrid.querySelector('.color-pack-swatch:not(.color-pack-custom)').getAttribute('data-color'),
    size: sizeRow.querySelector('.size-btn').getAttribute('data-size'),
    customCounts: {},
    customSizes: {}
  };

  var packLabelEl = document.getElementById('PackSummaryLabel');
  var packQtyEl = document.getElementById('PackSummaryQty');
  var sizeLabelEl = document.getElementById('SizeSummaryLabel');

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.hidden = true;
  }

  function updatePackSummary() {
    if (packQtyEl) packQtyEl.textContent = '(x' + state.qty + ')';
    if (!packLabelEl) return;
    if (state.mode === 'custom') {
      packLabelEl.textContent = 'Personalizado';
    } else {
      packLabelEl.textContent = state.color;
    }
  }

  function updateSizeSummary() {
    if (sizeLabelEl) sizeLabelEl.textContent = state.size;
    var badge = document.getElementById('MiPackSizeBadge');
    if (badge) badge.textContent = state.size;
  }

  colorGrid.querySelectorAll('.color-pack-swatch:not(.color-pack-custom)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.color = btn.getAttribute('data-color');
      state.mode = 'simple';
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      updatePackSummary();
      hideError();
    });
  });

  sizeRow.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.size = btn.getAttribute('data-size');
      sizeRow.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      updateSizeSummary();
      hideError();
    });
  });

  // ---- MiPack custom builder ----
  var modal = document.getElementById('MiPackModal');
  var openBtn = document.getElementById('OpenMiPack');
  var closeBtn = document.getElementById('MiPackClose');
  var confirmBtn = document.getElementById('MiPackConfirm');
  var countLabel = document.getElementById('MiPackCountLabel');
  var progressFill = document.getElementById('MiPackProgressFill');
  var selectedList = document.getElementById('MiPackSelectedList');
  var colorCards = modal ? modal.querySelectorAll('.mipack-color-card') : [];

  function miPackTotal() {
    return Object.keys(state.customCounts).reduce(function (sum, key) { return sum + state.customCounts[key]; }, 0);
  }

  function renderMiPack() {
    var total = miPackTotal();
    if (countLabel) countLabel.textContent = 'Número de artículos: ' + total + ' / ' + state.qty;
    if (progressFill) progressFill.style.width = Math.min(100, (total / state.qty) * 100) + '%';
    if (confirmBtn) confirmBtn.disabled = total !== state.qty;

    colorCards.forEach(function (card) {
      var color = card.getAttribute('data-color');
      var count = state.customCounts[color] || 0;
      var countEl = card.querySelector('.mipack-color-count');
      if (countEl) {
        countEl.textContent = count;
        countEl.hidden = count === 0;
      }
    });

    if (selectedList) {
      selectedList.innerHTML = '';
      Object.keys(state.customCounts).forEach(function (color) {
        var count = state.customCounts[color];
        if (count <= 0) return;
        var item = document.createElement('div');
        item.className = 'mipack-selected-item';
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'mipack-remove-btn';
        removeBtn.setAttribute('data-color', color);
        removeBtn.textContent = '−';
        var label = document.createElement('span');
        var itemSize = state.customSizes[color] || state.size;
        label.textContent = count + ' × ' + color + ' (' + itemSize + ')';
        item.appendChild(removeBtn);
        item.appendChild(label);
        selectedList.appendChild(item);
      });
      selectedList.querySelectorAll('.mipack-remove-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var color = btn.getAttribute('data-color');
          state.customCounts[color] = Math.max(0, (state.customCounts[color] || 0) - 1);
          renderMiPack();
        });
      });
    }
  }

  if (openBtn && modal) {
    openBtn.addEventListener('click', function () {
      state.customCounts = {};
      state.customSizes = {};
      modal.querySelectorAll('.mipack-color-size').forEach(function (select) {
        select.value = state.size;
      });
      updateSizeSummary();
      renderMiPack();
      modal.hidden = false;
    });
  }
  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function () {
      modal.hidden = true;
    });
  }
  colorCards.forEach(function (card) {
    var addTarget = card.querySelector('[data-action="add"]');
    var sizeSelect = card.querySelector('.mipack-color-size');
    if (!addTarget) return;
    addTarget.addEventListener('click', function () {
      var color = card.getAttribute('data-color');
      if (miPackTotal() >= state.qty) return;
      if (sizeSelect) state.customSizes[color] = sizeSelect.value;
      state.customCounts[color] = (state.customCounts[color] || 0) + 1;
      renderMiPack();
    });
  });
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (miPackTotal() !== state.qty) return;
      state.mode = 'custom';
      updatePackSummary();
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      modal.hidden = true;
      addToCartAndCheckout();
    });
  }

  // ---- Cart + checkout ----
  var addButtonOriginalText = addButton.textContent;

  function addToCartAndCheckout() {
    var items = [];

    if (state.mode === 'custom') {
      var colors = Object.keys(state.customCounts).filter(function (c) { return state.customCounts[c] > 0; });
      if (!colors.length) {
        showError('Elige al menos un color para tu MiPack.');
        return;
      }
      for (var i = 0; i < colors.length; i++) {
        var checkSize = state.customSizes[colors[i]] || state.size;
        var checkVariant = findVariant(colors[i], checkSize, state.pack);
        if (!checkVariant || !checkVariant.available) {
          showError('La combinación ' + colors[i] + ' / ' + checkSize + ' no está disponible. Prueba con otra talla.');
          return;
        }
      }
      for (var j = 0; j < colors.length; j++) {
        var itemSize = state.customSizes[colors[j]] || state.size;
        var itemVariant = findVariant(colors[j], itemSize, state.pack);
        items.push({ id: itemVariant.id, quantity: state.customCounts[colors[j]] });
      }
    } else {
      var singleVariant = findVariant(state.color, state.size, state.pack);
      if (!singleVariant || !singleVariant.available) {
        showError('La combinación ' + state.color + ' / ' + state.size + ' no está disponible. Prueba con otro color o talla.');
        return;
      }
      items.push({ id: singleVariant.id, quantity: state.qty });
    }

    hideError();
    addButton.disabled = true;
    addButton.textContent = 'Procesando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
      .then(function () {
        addButton.disabled = false;
        addButton.textContent = addButtonOriginalText;
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else if (typeof window.nyClick === 'function') {
          window.nyClick();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.textContent = addButtonOriginalText;
        showError('No pudimos agregar tu paquete al carrito. Intenta de nuevo.');
      });
  }

  addButton.addEventListener('click', addToCartAndCheckout);

  // ---- Pack quantity shortcuts ----
  var totalPriceEl = document.getElementById('PackTotalPrice');
  var stickyPriceEl = document.getElementById('StickyCtaPrice');
  var topPriceEl = document.getElementById('ProductUnitPrice');
  var topPriceLabelEl = document.getElementById('ProductPriceLabel');
  var updateTotal = function (btn) {
    if (!btn) return;
    var formatted = btn.getAttribute('data-total-price-formatted');
    if (!formatted) return;
    if (totalPriceEl) totalPriceEl.textContent = formatted;
    if (stickyPriceEl) stickyPriceEl.textContent = formatted;
  };
  var updateUnitPrice = function (btn) {
    if (!topPriceEl || !btn) return;
    var formatted = btn.getAttribute('data-unit-price-formatted');
    if (!formatted) return;
    topPriceEl.textContent = formatted;
    if (topPriceLabelEl) topPriceLabelEl.textContent = 'por paquete';
  };

  var shortcuts = document.querySelectorAll('[data-set-quantity]');
  var markActive = function (value) {
    shortcuts.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-set-quantity') === String(value));
    });
  };
  shortcuts.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var qty = parseInt(btn.getAttribute('data-set-quantity'), 10);
      state.qty = qty;
      state.pack = btn.getAttribute('data-pack');
      state.mode = 'simple';
      state.customCounts = {};
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b, idx) { b.classList.toggle('is-active', idx === 0); });
      if (colorIndex !== -1) state.color = colorGrid.querySelector('.color-pack-swatch:not(.color-pack-custom)').getAttribute('data-color');
      markActive(qty);
      updatePackSummary();
      updateTotal(btn);
      updateUnitPrice(btn);
      hideError();
    });
  });

  var firstShortcut = shortcuts[0];
  var initialQty = firstShortcut ? parseInt(firstShortcut.getAttribute('data-set-quantity'), 10) : 2;
  state.qty = initialQty;
  state.pack = firstShortcut ? firstShortcut.getAttribute('data-pack') : null;
  markActive(initialQty);
  updatePackSummary();
  updateSizeSummary();
  updateTotal(firstShortcut);
  updateUnitPrice(firstShortcut);
}
